import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import SafeImage from "@/components/SafeImage";
import { services, getServicePath } from "@/data/services";

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="tw-section relative"
    >
      <div
        className="glow-blob"
        style={{
          top: "20%",
          right: "-15%",
          width: 500,
          height: 500,
          background: "radial-gradient(circle, #1fa8ff 0%, transparent 60%)",
          opacity: 0.25,
        }}
      />

      <div className="relative z-10 tw-container">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 mb-10 md:mb-20 items-end">
          <div className="md:col-span-6">
            <div className="overline">02 — Usluge</div>
            <h2 className="mt-4 md:mt-6 tw-heading-section">
              Profesionalno pranje
              <br />
              <span className="blue-text font-display italic">za vaš objekat.</span>
            </h2>
          </div>
          <div className="md:col-span-5 md:col-start-8">
            <p className="text-[#c8d6ec] text-base md:text-lg leading-relaxed">
              Svaka usluga ima poseban fokus, poseban proces i posebnu stranicu sa
              detaljima — od hotelske posteljine i restoranskog tekstila, do
              uniformi, jorgana i organizovane rotacije u Beogradu.
            </p>
          </div>
        </div>

        <div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6"
          data-testid="services-grid"
        >
          {services.map((s, idx) => {
            const Icon = s.icon;
            return (
              <motion.article
                key={s.slug}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, delay: (idx % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
                data-testid={`service-item-${idx}`}
                className="tw-card p-0 overflow-hidden group"
              >
                <Link to={getServicePath(s.slug)} className="block p-5 sm:p-7 md:p-8 lg:p-10">
                  <div className="relative mb-5 sm:mb-6 md:mb-8 h-40 sm:h-44 md:h-48 overflow-hidden rounded-t-[24px] -mt-px">
                    <SafeImage
                      src={s.image}
                      alt={s.imageAlt}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                      loading="lazy"
                      sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#030812] via-[#030812]/20 to-transparent" />
                  </div>

                  <div className="flex items-start justify-between mb-6">
                    <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#55d0ff]/25 to-[#0b6cc9]/25 border border-[#55d0ff]/30 flex items-center justify-center relative">
                      <Icon size={26} strokeWidth={1.8} className="text-[#a7e2ff] relative z-10" />
                    </div>
                    <span className="overline text-[10px] text-[#8ea6c8]">
                      {String(idx + 1).padStart(2, "0")}
                    </span>
                  </div>

                  <h3 className="font-heading-md text-xl md:text-2xl text-white leading-snug group-hover:text-[#55d0ff] transition-colors">
                    {s.title}
                  </h3>
                  <p className="mt-4 text-[#a7bcd6] text-sm md:text-base leading-relaxed">
                    {s.cardDesc}
                  </p>
                  <div className="mt-8 pt-6 border-t border-[#55d0ff]/12 flex items-center justify-between">
                    <span className="overline text-[10px]">{s.tag}</span>
                    <span
                      aria-hidden
                      className="text-[#55d0ff] group-hover:translate-x-1 transition-transform duration-500 text-xl"
                    >
                      →
                    </span>
                  </div>
                </Link>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
